import { createReducer, createSelector, on } from "@ngrx/store";
import { OrderSource } from "./models/OrderSource";
import { loadOrderSourcesListSuccess } from "./order.actions";

export interface IOrdersState {
  allOrderSources: OrderSource[];
}

export const initialOrderState: IOrdersState = {
  allOrderSources: []
};

export const orderReducer = createReducer(
  initialOrderState,
  // Add action handlers here
  on(
    loadOrderSourcesListSuccess,
    (state, action) => {
      return {
        ...state
      }
    }
  ),
);

export const selectOrderState = createSelector(
  (state: any) => state,
  (state) => state.OrderState
);

export const selectAllOrderSourceList = createSelector(
  selectOrderState,
  (state: IOrdersState) => state.allOrderSources
);
